import { useLingui } from '@lingui/react/macro'
import type { MatchedDatapoint } from 'features/timeSeries'
import React from 'react'

import { InstrumentTimeSeriesTooltip } from './InstrumentTimeSeriesTooltip'
import { calculateTooltipPosition } from './PositionedTooltip'
import { Tooltip } from './styles'

export interface SubjectTimeSeriesTooltipProps {
  label: string
  matchedDatapoints: MatchedDatapoint[]
  tooltipPosition: { x: number; y: number }
  viewportWidth: number
  viewportHeight: number
}

/**
 * Hover tooltip for a subject's alias highlight: the subject's linked
 * datastreams as a sparkline, positioned like the OCR-box tooltip.
 */
export function SubjectTimeSeriesTooltip({
  label,
  matchedDatapoints,
  tooltipPosition,
  viewportWidth,
  viewportHeight,
}: SubjectTimeSeriesTooltipProps) {
  const { t } = useLingui()
  const { leftPos, topPos, renderBelow } = calculateTooltipPosition(
    tooltipPosition,
    320,
    350,
    viewportWidth,
    viewportHeight
  )

  return (
    <Tooltip
      $left={leftPos}
      $top={topPos}
      $transform={renderBelow ? 'translate(-50%, 0)' : 'translate(-50%, -100%)'}
      $noPadding>
      <InstrumentTimeSeriesTooltip
        label={label}
        matchedDatapoints={matchedDatapoints}
        clickHint={t`subject details`}
      />
    </Tooltip>
  )
}
